import styled from '@emotion/styled'
import { tone, ui } from '../../../utils/uiTokens'

export const Wrapper = styled.div`
    margin: 10px;
    border-radius: 16px;
`
export const Title = styled.div`
    margin-bottom: 20px;
    text-align: left;
    display: flex;
    align-items: center;
`

export const Content = styled.div`
    background-color: ${ui.card};
    border-radius: 16px;
    padding: 20px;
    min-height: 80vh;
`

export const Header = styled.header`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`

export const error = {
    color: tone.bad.text,
    marginLeft: 2,
}
